import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";
import {renderBulletText} from "../../../helpers/StringHelper";

export function LevelAKnowledgeDefinitionText({knowledgeDefinition}) {
    // Used in SystemQuestionKnowledge to display Knowledge
    // definition text to know by heart

    // BUILD
    if (isNullOrUndefined(knowledgeDefinition))
        return null
    return (
        <MathJaxContext>
            <MathJax inline dynamic>
                <div className={"mt-[12px] whitespace-pre-line text-white text-[18px] font-semibold"}>
                    {renderBulletText(knowledgeDefinition)}
                </div>
            </MathJax>
        </MathJaxContext>
    );
}